import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo } from 'react';
import { LRUMap } from 'lru_map';
import { useSmartLinkContext } from '@atlaskit/link-provider';
import { request } from '@atlaskit/linking-common';
import { useResolverUrl } from '../use-resolver-url';
var URL_RESPONSE_CACHE_SIZE = 50;
export var datasourceDetailsResponsePromiseCache = new LRUMap(URL_RESPONSE_CACHE_SIZE);
export var datasourceDataResponsePromiseCache = new LRUMap(URL_RESPONSE_CACHE_SIZE);
export var DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE = 20;
export var useDatasourceClientExtension = function useDatasourceClientExtension() {
  var _useSmartLinkContext = useSmartLinkContext(),
    client = _useSmartLinkContext.connections.client;
  var resolverUrl = useResolverUrl(client);
  var cachedRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(datasourceId, data, url, lruMap, force) {
      var cacheKeyData, cacheKey, responsePromise;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cacheKeyData = _objectSpread(_objectSpread({}, data), 'fields' in data ? {
              fields: _toConsumableArray(data.fields || []).sort()
            } : {});
            cacheKey = JSON.stringify({
              datasourceId: datasourceId,
              cacheKeyData: cacheKeyData
            });
            if (force) {
              lruMap.delete(cacheKey);
            }
            responsePromise = lruMap.get(cacheKey);
            if (!responsePromise) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", responsePromise);
          case 6:
            _context.prev = 6;
            responsePromise = request('post', url, data, undefined, [200, 201, 202, 203, 204]);
            lruMap.set(cacheKey, responsePromise);
            _context.next = 11;
            return responsePromise;
          case 11:
            return _context.abrupt("return", _context.sent);
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);
            lruMap.delete(cacheKey);
            throw _context.t0;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 14]]);
    }));
    return function cachedRequest(_x, _x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();
  var getDatasourceDetails = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(datasourceId, data) {
      var force,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            force = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            return _context2.abrupt("return", cachedRequest(datasourceId, data, "".concat(resolverUrl, "/datasource/").concat(datasourceId, "/fetch/details"), datasourceDetailsResponsePromiseCache, force));
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }(), [resolverUrl]);
  var getDatasourceData = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(datasourceId, data) {
      var force,
        _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            force = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
            return _context3.abrupt("return", cachedRequest(datasourceId, data, "".concat(resolverUrl, "/datasource/").concat(datasourceId, "/fetch/data"), datasourceDataResponsePromiseCache, force));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }(), [resolverUrl]);
  return useMemo(function () {
    return {
      getDatasourceDetails: getDatasourceDetails,
      getDatasourceData: getDatasourceData
    };
  }, [getDatasourceDetails, getDatasourceData]);
};